export default __webpack_public_path__ + "static/media/VD3.a113f05f.png";